import React from "react";
import Marquee from "react-fast-marquee";
import "./optimization.css";
import useScrollWatcher from "../Shared/ScrollWatcher";

const clients = [
  "Empty",
  "bosch-service",
  "oxford-medical",
  "shuvar",
  "musician",
  "arden-palace",
  "alpha",
  "k-med",
  "car-wash-point",
  "lbs",
  "iqmed",
  "royal-kebab",
  "maristella",
  "tehnomed",
  "epilook",
  "chacha",
  "fryway",
  "intima",
  "instytut-zoru",
  "prodental",
  "puzzlean",
  "chesni-pamyatnyky",
  "chernowizza",
  "ded-eats",
  "imed",
  "riverflow",
  "wavi",
  "bprygod",
  "geneva",
  "lux-medical",
  "butchery",
  "luckymotors",
  "pazen",
  "tbilisi-fm",
  "victor-dim",
  "dea-dent",
  "sedan",
  "1-pravova",
  "sakura",
  "shvydkist",
  "ozzi",
  "mars",
];
const vtClients = [
  "Empty",
  "kfc",
  "socar",
  "silpo",
  "retroville",
  "avalon",
  "river",
  "dominos",
  "radisson",
  "piraeus",
  "appollo",
];

const ClientsMarquee = ({ forVirtualTour = false }) => {
  const [marqueeRef, isMarqueeActive] = useScrollWatcher();
  return (
    <div ref={marqueeRef}>
      <Marquee
        play={isMarqueeActive}
        speed={75}
        className={"marquee-container"}
        pauseOnClick={false}
        pauseOnHover={false}
        gradient={true}
        gradientColor={"white"}
        gradientWidth={"10vw"}
      >
        {forVirtualTour
          ? vtClients.map((logo, index) => (
              <img
                key={index}
                src={`./img/optimization/clients/${logo}.png`}
                alt={`Client ${index + 1}`}
                className={"marquee-item"}
                style={{
                  maxHeight: "100px",
                  margin: "0 20px",
                  maxWidth: "200px",
                }}
              />
            ))
          : clients.map((logo, index) => (
              <img
                key={index}
                src={`./img/optimization/clients/${logo}.png`}
                alt={`Client ${index + 1}`}
                className={"marquee-item"}
                style={{
                  maxHeight: "100px",
                  margin: "0 20px",
                  maxWidth: "200px",
                }}
              />
            ))}
      </Marquee>
    </div>
  );
};

export default ClientsMarquee;
